import { render, staticRenderFns } from "./card-element.vue?vue&type=template&id=3338687d&scoped=true"
import script from "./card-element.vue?vue&type=script&lang=js"
export * from "./card-element.vue?vue&type=script&lang=js"
import style0 from "./card-element.vue?vue&type=style&index=0&id=3338687d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3338687d",
  null
  
)

export default component.exports